import AppService from './AppService';

class StatsService extends AppService {
  constructor() {
    super();
    this.path = this.getPath('stats');
  }
  getStats(params = {}) {
    return this.http.get(`${this.path}`, { params });
  }
}

export default StatsService;
